import {
  Database, Server, Cpu, Globe, Terminal, Shield,
  Code2, Workflow, Layers, Network, Cloud, Lock,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface ProjectIcon {
  key: string;
  label: string;
  Icon: LucideIcon;
}

export const PROJECT_ICONS: ProjectIcon[] = [
  { key: "lucide:database", label: "Database", Icon: Database  },
  { key: "lucide:server",   label: "Server",   Icon: Server    },
  { key: "lucide:cpu",      label: "CPU",       Icon: Cpu       },
  { key: "lucide:globe",    label: "Globe",     Icon: Globe     },
  { key: "lucide:terminal", label: "Terminal",  Icon: Terminal  },
  { key: "lucide:shield",   label: "Shield",    Icon: Shield    },
  { key: "lucide:code",     label: "Code",      Icon: Code2     },
  { key: "lucide:workflow", label: "Workflow",  Icon: Workflow  },
  { key: "lucide:layers",   label: "Layers",    Icon: Layers    },
  { key: "lucide:network",  label: "Network",   Icon: Network   },
  { key: "lucide:cloud",    label: "Cloud",     Icon: Cloud     },
  { key: "lucide:lock",     label: "Lock",      Icon: Lock      },
];

export function isLucideKey(s: string): boolean {
  return s.startsWith("lucide:");
}

export function getLucideIcon(key: string): LucideIcon | undefined {
  return PROJECT_ICONS.find((e) => e.key === key)?.Icon;
}
